<template>
  <div>
    <div class="Informationrelease" v-if="InfoFlag">
      <div class="InformationreleaseTop" v-show="InformationArr.length > 0">
        <!-- <div class="btnFB">
          <Btn width="100px" height="32px" title="发布资讯" :src="require('@/assets/channel/ZX.png')" backgroundColor="#E71D43" color="#FFF" @btnclick="ReleaseInformation"></Btn>
        </div> -->
        <div class="FromComm">
          <FromComm :FromArr="FromArr"></FromComm>
        </div>
        <SearchComm placeholder="资讯名称" @searchClick="searchClick" :width="205"></SearchComm>
      </div>

      <div class="InformationreleaseCenter">
        <div v-if="InformationArr.length > 0">
          <div class="AllRead">
            <div class="ReadText" @click="SeeAll">全部标记为已读</div>
          </div>
          <Informationlist :InformationArr="InformationArr" @SeeInfo="SeeInfoClick"></Informationlist>
          <div class="pagination">
            <Pagination type="allColor" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
          </div>
        </div>
        <div v-else style="margin-top: 118px;">
          <img src="@/assets/DefaultPage/Informationrelease.png" alt="" width="640px" height="480px" style="margin-left: 250px;margin-bottom: 150px;">
        </div>
      </div>

      <DialogFrom width="1000px" title="发布新的资讯" rigthText="发布" :dialogVisible="dialogVisibleNewInformation" @cancel="cancelNewInformation" @dialogOK="dialogOKNewInformation">
        <div class="InforDialog">
          <FromComm :FromArr="FromArrs" @selectAll="selectAll" @removeTag="removeTag" @InforSelectChange="InforSelectChange"></FromComm>
          <div class="textarea">
            <el-input type="textarea" placeholder="请输入内容" v-model="Informationtextarea" show-word-limit>
            </el-input>
          </div>
          <div class="UploadFile">
            <Upload width="90px" backgroundColor="#FAFBFC" title="选择文件" :src="require('@/assets/channel/Selectfile.png')" @getFile="SelectFile"></Upload>
            <div class="remarks">请添加附件，可添加多个，单个文件大小请勿超过20M</div>
          </div>
          <div class="UpAd">
            <CommUploadAdditional width="460px" backgroundColor="#FAFBFC" :fileData="FileList" :srcleft="require('@/assets/channel/icon-FJ.png')" :srcright="require('@/assets/channel/del.png')"></CommUploadAdditional>
          </div>
        </div>
      </DialogFrom>
    </div>
    <div v-else>
      <SeeInfo @toHome="toHome" :InformationInfoListprops="InformationInfoList"></SeeInfo>
    </div>
  </div>

</template>

<script>
import Btn from '../../../../../components/common-btn.vue'
import FromComm from '../../components/fromComponents/Commfrom/from-comm.vue'
import SearchComm from '../../../../../components/comm-from-search.vue'
import Informationlist from './components/InformationList.vue'
import Pagination from '../../../../../components/pagination.vue'
import DialogFrom from '../../../../../components/dialog-from.vue'
import SeeInfo from './SeeInfo.vue'
import Upload from '../../../../../components/common-upload'
import CommUploadAdditional from '../../../../../components/comm-upload-additional.vue'
import FromArr from '../FromData/FromArr'
import {
  InformationInfo,
  InformationList,
  InformationGetCreatorList
} from '@/api/home'
import {
  InformationView,
  InformationSetAllView,
} from '@/api/channel'


export default {
  components: { Btn, FromComm, SearchComm, Informationlist, Pagination, DialogFrom, Upload, CommUploadAdditional, SeeInfo },
  props: {},
  data() {
    return {
      FromArr: [],
      dialogVisibleNewInformation: false,
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      Informationtextarea: "",
      TitleSearch: "",
      InfoFlag: true,
      InformationInfoList: null,
      FileList: [
        {
          fileTitle: "这里是一个附加文件1"
        },
        {
          fileTitle: "这里是一个附加文件12"
        },
        {
          fileTitle: "这里是一个附加文件13"
        },
        {
          fileTitle: "这里是一个附加文件14"
        }
      ],
      FromArrs: [
        {
          title: "",
          modelvalue: "",
          inputtype: "input",
          inputflag: true,
          fontSize: 14,
          color: "#424E66",
          lableheight: 0,
          types: "text",
          placeholder: "请输入资讯标题",
          width: 936,
          height: 32,
          disabled: false,
          marginLeft: 5,
          marginTop: 0,
          X: false,
        },
        {
          title: "",
          modelvalue: [],
          inputtype: "selectMultiple",
          inputflag: true,
          fontSize: 14,
          color: "#424E66",
          lableheight: 5,
          types: "text",
          placeholder: "发布人",
          width: 948,
          // height: 0,
          disabled: false,
          marginLeft: 5,
          marginTop: 0,
          X: false,
          event: "InforSelectChange",
          options: [

          ]
        },
      ],
      InformationArr: []
    }
  },
  created() {

  },
  mounted() {
    this.FromArr = JSON.parse(JSON.stringify(FromArr))
    this.InformationList()
    this.InformationGetCreatorList()
  },
  activated() { },
  updated() { },
  methods: {

    // ListApi
    async InformationList() {
      console.log(FromArr[0].modelvalue);
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message,
        data
      } = await InformationList({
        title: this.TitleSearch,
        Creator: this.FromArr[0].modelvalue,
        createTime1: this.FromArr[1].StartTime,
        createTime2: this.FromArr[1].EndTime,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      if (code == 0) {
        this.total = data.Count
        this.InformationArr = data.data
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    //InfoApi
    // async InformationInfo(InfoID) {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: '正在加载...',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(255,255,255,0.3)'
    //   });
    //   let {
    //     code,
    //     message,
    //     data
    //   } = await InformationInfo({
    //     infoID: InfoID
    //   })
    //   if (code == 0) {
    //     this.InformationInfoList = data
    //     this.InfoFlag = false
    //   } else {
    //     this.$message.warning(message)
    //   }
    //   loading.close();
    // },
    // 已读INFO API
    async InformationView(InfoID) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message,
        data
      } = await InformationView({
        infoID: InfoID
      })
      if (code == 0) {
        this.InformationInfoList = data
        this.InfoFlag = false
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    // 发布人下拉
    async InformationGetCreatorList() {
      let {
        code,
        data,
        message
      } = await InformationGetCreatorList({
      })
      if (code == 0) {
        this.FromArr[0].options = []
        data.forEach((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.FromArr[0].options.push(obj)
        });
      } else {
        this.$message.warning(message)
      }
    },
    //全部已读
    async InformationSetAllView() {
      let {
        code,
        message,
        data
      } = await InformationSetAllView({
      })
      if (code == 0) {
        this.InformationList()
      } else {
        this.$message.warning(message)
      }
    },
    // 单条已读和单条详情
    SeeInfoClick(par) {
      this.InformationView(par.InfoID)
    },
    // 全部已读
    SeeAll() {
      this.InformationSetAllView()
    },
    // 发布资讯
    ReleaseInformation() {
      this.dialogVisibleNewInformation = true
    },
    // 搜索
    searchClick(val) {
      this.TitleSearch = val;
      this.pageIndex = 1
      this.InformationList()
    },
    SelectFile(file) {

    },

    // 详情返回上层
    toHome() {
      this.InfoFlag = true
      if (this.InfoFlag) {
        this.InformationList()
      }
    },

    // 全选
    selectAll() {
      if (this.FromArrs[1].modelvalue.length < this.FromArrs[1].options.length) {
        this.FromArrs[1].modelvalue = []
        this.FromArrs[1].options.map((item) => {
          this.FromArrs[1].modelvalue.push(item.value)
        })
        this.FromArrs[1].modelvalue.unshift('全选')
      } else {
        this.FromArrs[1].modelvalue = []
      }
    },
    // 多选的Change事件
    InforSelectChange(e) {
      if (!e.FromArr[1].modelvalue.includes('全选') && e.FromArr[1].modelvalue.length === this.FromArrs[1].options.length) {
        this.FromArrs[1].modelvalue.unshift('全选')
      } else if (e.FromArr[1].modelvalue.includes('全选') && (e.FromArr[1].modelvalue.length - 1) < this.FromArrs[1].options.length) {
        this.FromArrs[1].modelvalue = this.FromArrs[1].modelvalue.filter((item) => {
          return item !== '全选'
        })
      }
    },
    // 删除全选选项全部删除
    removeTag(val) {
      if (val === '全选') {
        this.FromArrs[1].modelvalue = []
      }
    },
    handleSizeChange(PageSize) {
      this.pageSize = PageSize;
      this.InformationList();
      this.$emit("handleSizeChange", PageSize)
    },
    handleCurrentChange(PageIndex) {
      this.pageIndex = PageIndex;
      this.InformationList();
      this.$emit("handleCurrentChange", PageIndex)
    },
    cancelNewInformation() {
      this.dialogVisibleNewInformation = false
    },
    dialogOKNewInformation() {
      this.dialogVisibleNewInformation = false
    }
  },
  computed: {},
  watch: {
    $route: {
      handler(to,from) {
        // 监听首页资讯跳转，校验参数打开详情
        if(to.query.infoID && to.query.type == 'Home'){
            this.InformationView(to.query.infoID)
        }
      },
      deep: true,
      immediate: true
    }
  },
}
</script>
<style scoped lang='less'>
.InformationreleaseTop {
  width: 1200px;
  height: 64px;
  background-color: #ffffff;
  margin: 16px auto;
  position: relative;
  top: 16px;
  user-select: none;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #eaecef;

  .btnFB {
    position: relative;
    top: 5px;
  }

  .FromComm {
    position: absolute;
    display: inline-block;
    top: -40px;
    right: 290px;
  }
}
.InforDialog {
  max-height: 632px;
  overflow-y: scroll;
}

.InformationreleaseCenter {
  width: 1120px;
  min-height: 480px;
  background-color: #ffffff;
  margin: 33px auto;
  position: relative;
  padding: 0px 40px 0 40px;

  .AllRead {
    width: 100%;
    height: 79px;
    border-bottom: 1px solid #f2f3f5;
    user-select: none;

    .ReadText {
      font-size: 16px;
      color: #424e66;
      line-height: 79px;
      float: right;
      cursor: pointer;
    }
    .ReadText:hover {
      color: #424e66;
    }
  }
}
.textarea {
  margin-top: 16px;
}

.UploadFile {
  margin-left: -5px;
}
.remarks {
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: #9ca5b8;
}
.UpAd {
}
</style>